import {useParams} from '@/router/router';
import {getAmexSolution} from '@/store/state/helpers';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
import {computed} from '@vue/composition-api';
import {PlaceCardItem} from '@common/place-card-logic/place-card-logic';
import {usePlaceCardUtils} from './place-card-utils';

export function useStay() {
  const {getActivityPrice} = usePlaceCardUtils();
  const solution = computed(() => {
    return getAmexSolution();
  });

  const stayActivity = computed(() => {
    const params = useParams();
    const context = params.value.contextName;
    const all =
      solution.value?.activities.filter(
        (x) =>
          // @ts-ignore
          x.category === UserActivityCategoryEnum.ACCOMMODATION && x.source?.content && x.spec?.context === context,
      ) || [];
    return all.find(Boolean);
  });

  const stay = computed<PlaceCardItem | null>(() => {
    const first = stayActivity.value;
    const content = first?.source?.content;
    if (!first || !content) {
      return null;
    }

    return {
      id: first.id,
      img: first.images.medium,
      name: first.name,
      category: first.category,
      description: first.description || '',
      explanations: first.explanations || [],
      isActivity: true,
      isFlexible: false,
      price: getActivityPrice(first),
      icon: null,
      rating: first.rating,
      tags: [],
      isRecommendation: false,
      bookingUrl: content?.booking_url || '',
      webURL: content?.url,
    };
  });

  const allStayActivities = computed(() => {
    return (
      (solution.value?.activities || []).filter(
        (x) => x.category === UserActivityCategoryEnum.ACCOMMODATION && x.source?.content?.booking_url,
      ) || []
    );
  });

  return {
    stay,
    solution,
    stayActivity,
    allStayActivities,
  };
}
